export enum Mensagens {
	INFORMACOES_GERAIS = 'Informações gerais',
}
